import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X, Send } from 'lucide-react';
import ktcLogo from '../assets/ktc.png';

const WhatsAppButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = '6281312222230'; // KTC WhatsApp number
  const defaultMessage = 'Halo Kedai Teknologi Celebes! Saya ingin bertanya tentang layanan internet.';

  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(defaultMessage);
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
  };

  return (
    <div className="fixed bottom-24 right-6 z-50" data-testid="whatsapp-button">
      {/* Chat Popup */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            className="absolute bottom-20 right-0 w-80 bg-[#121212] rounded-2xl shadow-2xl border border-white/10 overflow-hidden"
          >
            {/* Header */}
            <div className="bg-[#25D366] p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                    <img 
                      src={ktcLogo}
                      alt="KTC"
                      className="w-8 h-8 object-contain"
                    />
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm">Dukungan Kedai Teknologi Celebes</p>
                    <p className="text-white/80 text-xs">Online</p>
                  </div>
                </div>
                <button 
                  onClick={() => setIsOpen(false)}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>

            {/* Chat Body */}
            <div className="p-4 bg-[#0A0A0A]">
              {/* Welcome Message */}
              <div className="bg-[#1a1a1a] rounded-lg p-3 max-w-[85%] mb-4">
                <p className="text-white text-sm">
                  Halo! 👋 Selamat datang di Kedai Teknologi Celebes.
                </p>
                <p className="text-gray-400 text-sm mt-2">
                  Ada yang bisa kami bantu? Tim kami siap melayani pertanyaan Anda seputar layanan internet.
                </p>
                <p className="text-gray-500 text-xs mt-2 text-right">Sekarang</p>
              </div>

              {/* Quick Options */}
              <div className="space-y-2 mb-4">
                <button 
                  onClick={() => {
                    const msg = encodeURIComponent('Halo, saya ingin bertanya tentang paket internet untuk rumah.');
                    window.open(`https://wa.me/${phoneNumber}?text=${msg}`, '_blank');
                  }}
                  className="w-full text-left px-3 py-2 bg-[#121212] border border-white/10 rounded-lg text-sm text-gray-300 hover:border-[#25D366]/50 hover:text-[#25D366] transition-colors"
                >
                  📦 Tanya Paket Internet
                </button>
                <button 
                  onClick={() => {
                    const msg = encodeURIComponent('Halo, saya ingin cek ketersediaan jaringan di lokasi saya.');
                    window.open(`https://wa.me/${phoneNumber}?text=${msg}`, '_blank');
                  }}
                  className="w-full text-left px-3 py-2 bg-[#121212] border border-white/10 rounded-lg text-sm text-gray-300 hover:border-[#25D366]/50 hover:text-[#25D366] transition-colors"
                >
                  📍 Cek Ketersediaan
                </button>
                <button 
                  onClick={() => {
                    const msg = encodeURIComponent('Halo, saya pelanggan Kedai Teknologi Celebes dan ingin melaporkan gangguan.');
                    window.open(`https://wa.me/${phoneNumber}?text=${msg}`, '_blank');
                  }}
                  className="w-full text-left px-3 py-2 bg-[#121212] border border-white/10 rounded-lg text-sm text-gray-300 hover:border-[#25D366]/50 hover:text-[#25D366] transition-colors"
                >
                  🔧 Lapor Gangguan
                </button>
              </div>
            </div>

            {/* Footer */}
            <div className="p-3 border-t border-white/10">
              <button
                onClick={handleWhatsAppClick}
                className="w-full flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#20BA5C] text-white py-3 rounded-lg font-medium transition-colors"
                data-testid="whatsapp-chat-button"
              >
                <Send className="w-4 h-4" />
                Mulai Chat
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Floating Button */}
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setIsOpen(!isOpen)}
        className={`
          w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-colors
          ${isOpen ? 'bg-[#121212] border border-white/20' : 'bg-[#25D366] hover:bg-[#20BA5C]'}
        `}
        data-testid="whatsapp-toggle-button"
      >
        {isOpen ? (
          <X className="w-6 h-6 text-white" />
        ) : (
          <MessageCircle className="w-6 h-6 text-white" />
        )}
      </motion.button>

      {/* Pulse Animation */}
      {!isOpen && (
        <span className="absolute top-0 right-0 w-3 h-3">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-75"></span>
          <span className="relative inline-flex h-3 w-3 rounded-full bg-[#25D366]"></span>
        </span>
      )}
    </div>
  );
};

export default WhatsAppButton;

